module.exports = __webpack_public_path__ + "img/identity_card_bg1.63513132.png";